import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { HttpParams, HttpClient } from "@angular/common/http";
import { ApiCallingService } from "../../services/api-calling.service";
import { CsvService } from "../../services/csv.service";
import { ConfigApi } from "../../config-api";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { DomSanitizer } from "@angular/platform-browser";
import * as moment from "moment";
import { NgForm, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-users-advance-booking",
  templateUrl: "./users-advance-booking.component.html",
  styleUrls: ["./users-advance-booking.component.css"],
})
export class UsersAdvanceBookingComponent implements OnInit {
  @ViewChild("specialityform", { static: true }) specialityform: NgForm =
    Object.create(null);
  @ViewChild("exportModalContent") exportModalContent:
    | TemplateRef<any>
    | undefined;

  today: any = moment(new Date()).format("YYYY-MM-DD");
  startDate = moment().startOf("month").format("YYYY-MM-DD");
  endDate = moment().endOf("month").format("YYYY-MM-DD");
  exportForm: any;
  isExporting = false;
  isDateFilterActive = false;

  employeeList: any[] = [];
  selectedEmployeeId: string = "";
  loadingEmployees: boolean = false;
  preSelectedEmployee: any;

  constructor(
    private CsvService: CsvService,
    private sanitizer: DomSanitizer,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public Globals: Globals,
    public http: HttpClient,
    public datepipe: DatePipe,
    private modalService: NgbModal,
    private fb: FormBuilder
  ) {}

  currency: any = localStorage.getItem("CUR");
  isEmployee: any;

  ngOnInit(): void {
    this.getList("", "");
    this.isEmployee = this.Globals.getIsEmployee() == "true" ? true : false;

    this.exportForm = this.fb.group({
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],
    });

    this.exportForm.get("startDate").valueChanges.subscribe((val: any) => {
      const endDateControl: any = this.exportForm.get("endDate");
      endDateControl.setValidators([
        Validators.required,
        (control: any) => {
          if (!control.value) return null;
          const start = moment(val);
          const end = moment(control.value);
          return end.isBefore(start) ? { invalidDate: true } : null;
        },
      ]);
      endDateControl.updateValueAndValidity();
    });
  }

  modeltitle: any;
  page = 1;
  pageSize = 10;
  data = [];
  totalcount = 0;
  detail: any;

  getList(startDate: any, endDate: any) {
    const formattedStartDate = startDate || "";
    const formattedEndDate = endDate || "";

    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.ADVANCE_UPCOMING_BOOKING.LIST +
          "?operator_id=" +
          this.Globals.getUser()._id +
          "&page=" +
          (this.page <= 0 ? 0 : this.page - 1) +
          "&limit=" +
          this.pageSize +
          "&status=all" +
          "&start_date=" +
          formattedStartDate +
          "&endOf=" +
          formattedEndDate
      )
      .subscribe(
        (res) => {
          this.data = res.data;
          this.totalcount = res.total;
        },
        (error) => {
          this.toastr.error("Failed to load booking data");
        }
      );
  }

  filterbydate() {
    this.isDateFilterActive = true;

    this.page = 1;

    this.getList(this.startDate, this.endDate);
  }

  loadPage(page: number) {
    if (page) {
      this.page = page;

      if (this.isDateFilterActive) {
        this.getList(this.startDate, this.endDate);
      } else {
        this.getList("", "");
      }
    }
  }

  image: any;
  loadReceipt(id: any) {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.GET_TRANSACTIONS_RECEIPT + "?_id=" + id
      )
      .subscribe((res) => {
        if (!Array.isArray(res.data)) {
          window.open(res.data);
        } else {
          const aa = new Uint8Array(res.data);
          const file = new Blob([aa], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
      });
  }

  loadReceiptLeasePackage(URL: any) {
    if (URL) {
      window.open(URL);
    }
  }

  formatDate(date: Date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  float(amount: any, refundAmount: any) {
    amount = amount / 100;
    const result =
      Number.parseFloat(amount) == Number.parseFloat(refundAmount)
        ? true
        : false;
    return result;
  }

  truncate = (string = "") => {
    if (string.length > 15) {
      return string.substring(0, 15) + "...";
    }
    return string;
  };

  getCsv() {
    // Reset the form with default values
    this.exportForm.reset({
      startDate: "",
      endDate: "",
    });

    // Open the modal
    this.modalService.open(this.exportModalContent, {
      size: "lg",
      centered: true,
      backdrop: "static",
    });
  }

  closeBtnClick() {
    this.modalService.dismissAll();
  }

  exportWithSelectedDates() {
    this.isExporting = true;
    const startDate = this.exportForm.get("startDate").value;
    const endDate = this.exportForm.get("endDate").value;

    const params = new HttpParams()
      .set("operator_id", this.Globals.getUser()._id)
      .set("status", "all")
      .set("start_date", startDate)
      .set("endOf", endDate);

    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.ADVANCE_UPCOMING_BOOKING.CSVEXPORT +
          "?" +
          params.toString()
      )
      .subscribe(
        (res: any) => {
          const receiptData = res.data || [];
          const finalCsvData: any[] = [];

          receiptData.forEach((d: any, index: number) => {
            const isReceipt = !!d.receipt;
            const receipt = isReceipt ? d.receipt : d.stripe_response || {};

            const balanceData = receipt.balance_transaction_data || {};

            const csvEntry = {
              "Purchase Date":
                this.datepipe.transform(d?.created_at, "yyyy-MM-dd") || "-",
              "Package Title": d?.package_id?.title || "-",
              UserName: d?.user_id?.username || "-",
              "Email ID": d?.user_id?.email || "-",
              Mobile: d?.user_id?.mobile || "-",
              "User Address": d?.user_id?.address || "-",
              "Asset Type": d?.package_id?.type || "-",
              "Package Type":
                d?.package_type == "activities"
                  ? "Activities"
                  : d?.package_type == "self_serve"
                  ? "Self Serve"
                  : d?.package_type == "rentx"
                  ? "RentX"
                  : "-",
              Fees: d?.package_id?.price + " " + this.currency || "0",
              Deposite: d?.package_id?.security_deposit || "0",
              "Extra Charge Fee": d?.extra_ride_fee || 0,
              "Brand Name": d?.brand_name || "-",
              "Total Asset Allowed": d?.total_asset_used || 0,
              Duration: d?.package_id?.duration || "-",
              Timing: d?.package_id?.timing || "-",
              Vat: d?.package_id?.vat
                ? d?.package_id?.vat
                : d?.package_id?.vat == 0
                ? 0
                : "-",
              "Time Slot":
                moment(d?.start_date).format("hh:mm a") +
                "-" +
                moment(d?.end_date).format("hh:mm a"),
              "Start Date": moment(d?.start_date).format("ll") || "-",
              "End Date": moment(d?.end_date).format("ll") || "-",
              Status: this.getStatusName(d?.status) || "-",
            };

            finalCsvData.push(csvEntry);
          });

          this.CsvService.downloadAdvanceFile(
            finalCsvData,
            "Advance_Booking_History"
          );
          this.toastr.success("CSV exported successfully");
          this.isExporting = false;
          this.modalService.dismissAll();
        },
        (err) => {
          console.error("CSV Export Error:", err);
          this.toastr.error("Failed to export CSV");
          this.isExporting = false;
          this.modalService.dismissAll();
        }
      );
  }

  onSubmit(f: any) {
    console.log(
      "🚀 ~ file: transactions.component.ts:434 ~ TransactionsComponent ~ onSubmit ~ f:",
      f
    );
  }
  getStatusName(status: string) {
    switch (status) {
      case "expired":
        return "Expired";
      case "upcoming":
        return "Upcoming";
      case "active":
        return "Active";
      case "returned":
        return "Returned";
      case "completed":
        return "Completed";
      case "cancel_request":
        return "Cancel Request";
      case "refund_request":
        return "Refund Request";
      case "refunded":
        return "Refunded";
      case "cancelled":
        return "Cancelled";
      default:
        return "Cancelled";
    }
  }
  openModal(targetModal: NgbModal, data: any, title: any) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
    this.modeltitle = title;
    this.detail = Object.assign({}, data);
    this.loadEmployees();

    // Check if there are any pre-selected employees
    if (
      this.detail &&
      this.detail.employee_ids &&
      this.detail.employee_ids.length > 0
    ) {
      this.preSelectedEmployee = this.detail.employee_ids[0];
      this.selectedEmployeeId = this.preSelectedEmployee._id;
    } else {
      this.selectedEmployeeId = "";
      this.preSelectedEmployee = null;
    }
  }

  loadEmployees() {
    this.loadingEmployees = true;
    const user_id = this.Globals.getUser()._id;
    const query = "?operator_id=" + user_id;

    this.apiCallingService
      .callAPI({}, "GET", ConfigApi.URLS.EMPLOYEE_LIST + query)
      .subscribe(
        (res) => {
          console.log(res, "Employee list response");
          if (res.success && res.data) {
            this.employeeList = res.data;
          } else {
            this.employeeList = [];
            this.toastr.error("Failed to load employees");
          }
          this.loadingEmployees = false;
        },
        (error) => {
          console.error("Error loading employees:", error);
          this.employeeList = [];
          this.loadingEmployees = false;
          this.toastr.error("Error loading employees");
        }
      );
  }

  onAddEmployeeSubmit(form: any) {
    if (!form.valid || !this.selectedEmployeeId) {
      this.toastr.error("Please select an employee");
      return;
    }

    const payload = {
      advance_booking_id: this.detail._id,
      employee_id: this.selectedEmployeeId,
    };

    this.apiCallingService
      .callAPI(payload, "POST", ConfigApi.URLS.ASSIGN_EMPLOYEE_ADVANCE_BOOK)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Employee added successfully");
            this.closeBtnClick();
            this.ngOnInit();
          } else {
            this.toastr.error(res.msg || "Error adding employee");
          }
        },
        (error) => {
          console.error("Error adding employee:", error);
          this.toastr.error("Error adding employee");
        }
      );
  }

  closeAddEmployeeBtnClick() {
    this.selectedEmployeeId = "";
    this.preSelectedEmployee = null;
    this.employeeList = [];
    this.modalService.dismissAll();
  }
}
